import script from "./DashboardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeader.vue?vue&type=style&index=0&id=5afae499&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afae499"]])

export default __exports__